import formatCurrency from "utils/formatCurrency";
import { EnumCurrency } from "types/api/api";

interface ArgsType {
  totalPrice: number;
  currency?: EnumCurrency;
  t: (key: string) => string;
}

const getPayButtonTitle = ({ totalPrice, currency, t }: ArgsType): string => {
  return `${t("secondScreen.pay")} ${formatCurrency(totalPrice, currency)}`;
};

export default getPayButtonTitle;
